import { WorkflowStepCode } from '@exam-management/graphql';
import { Paper, SectionTitle, Flex, Text } from '@shared/components';
import { formatDate } from '@shared/utils';

import { ChangeAssigneeButton, ChangeDueDateButton } from '../../components';
import {
  useQuestionCreationTaskDetails,
  useQuestionCreationTaskDetailsModal,
} from '../../providers';

export default function QuestionCreationTaskInformation() {
  const { task, roles, status } = useQuestionCreationTaskDetails();

  const { openChangeAssigneeModal, openChangeDueDateModal } = useQuestionCreationTaskDetailsModal();

  const canChangeAssignee = roles.isOwner && status.code !== WorkflowStepCode.QuestionCreationDone;
  const canChangeDueDate = roles.isOwner && status.code !== WorkflowStepCode.QuestionCreationDone;

  const content = [
    {
      label: 'Task Name',
      value: task?.name ?? '-',
    },
    {
      label: 'Task Owner',
      value: task?.owner ? `${task.owner.firstname} ${task.owner.lastname}` : '-',
    },
    {
      label: 'Assignee',
      value: task?.assignee ? `${task.assignee.firstname} ${task.assignee.lastname}` : '-',
      action: canChangeAssignee ? <ChangeAssigneeButton onClick={openChangeAssigneeModal} /> : null,
    },
    {
      label: 'Due Date',
      value: formatDate(task.dueDate),
      action: canChangeDueDate ? <ChangeDueDateButton onClick={openChangeDueDateModal} /> : null,
    },
  ];

  return (
    <Paper
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        p: theme.spacing(6),
        gap: theme.spacing(4),
        borderRadius: theme.shape.rounded(2),
      })}
    >
      <SectionTitle title='Task Information' />
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(2),
        })}
      >
        {content.map(({ label, value, action }) => (
          <Flex sx={(theme) => ({ gap: theme.spacing(6) })} key={label}>
            <Text sx={{ width: '120px' }}>{label}:</Text>
            <Flex sx={(theme) => ({ gap: theme.spacing(2), alignItems: 'center' })}>
              <Text variant='body1Semibold'>{value}</Text>
              {action}
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Paper>
  );
}
